import React from 'react';
import styles from '../HomeV3.module.css';

interface Props {
    id: string;
    title: string;
    eyebrow: string;
    summary: string;
    className?: string;
    children: React.ReactNode;
}

export function ChartCard({ id, title, eyebrow, summary, className = '', children }: Props) {
    return (
        <section className={`${styles.panel} ${className}`} aria-labelledby={`${id}-title`} aria-describedby={`${id}-summary`}>
            <p className={styles.eyebrow}>{eyebrow}</p>
            <h2 id={`${id}-title`}>{title}</h2>
            <p id={`${id}-summary`} className={styles.muted}>{summary}</p>
            {children}
        </section>
    );
}
